import React,{useState} from 'react'
import CreateCustomerForm from './form';

const CreateCustomer = (props) => {

    const [formData, setFormData] = useState({
        first_name:'',
        last_name:'',
        email:'',
        organization_id:'',
        password:'',
        confirm_password:'',
    });
    

    return (
        <>
       <CreateCustomerForm data={formData}/>
        </>
    )
}

export default CreateCustomer
